import { render, staticRenderFns } from "./vesselCharterers.vue?vue&type=template&id=7b502ab4"
import script from "./vesselCharterers.vue?vue&type=script&lang=js"
export * from "./vesselCharterers.vue?vue&type=script&lang=js"
import style0 from "./vesselCharterers.vue?vue&type=style&index=0&id=7b502ab4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports